/**
 * dataLayer events.
 *
 * GTM (`GTM-NWFTSK3H`) and GA4 (`G-WGN529KWVB`) were live with click tags
 * only: the booking completes on fresha.com, the contact form set an inline
 * success state with no event and no thank-you URL, so clicks were recorded
 * and outcomes never were (fix plan P0-4).
 *
 * Every push goes through here so the event names stay a closed set that GTM
 * triggers can be built against. Pushing is safe before the container loads
 * (GTM replays the queue) and a no-op when analytics are gated off, since
 * `dataLayer` simply never gets drained.
 */

export type AnalyticsEvent =
  /** A visitor left for Fresha to book. The last measurable moment on-site. */
  | { event: "booking_handoff"; booking_target: string; source_page: string; cta_label?: string }
  /** A visitor left for Fresha to buy a gift voucher. */
  | { event: "voucher_handoff"; booking_target: string; source_page: string; cta_label?: string }
  /** Contact enquiry accepted by the API. */
  | { event: "generate_lead"; form_name: string; form_location: string }
  /** Newsletter subscription accepted by the API. */
  | { event: "newsletter_signup"; form_name: string; form_location: string };

type DataLayerWindow = Window & { dataLayer?: unknown[] };

export function pushEvent(payload: AnalyticsEvent) {
  if (typeof window === "undefined") return;
  const w = window as DataLayerWindow;
  w.dataLayer = w.dataLayer ?? [];
  w.dataLayer.push(payload);
}
